<template>
  <header class="layout-header">
    <div class="site-header-inner">
      <a class="site-brand" href="#/index" aria-label="金电保数字科技首页" @click.prevent="navigateTo('col')">
        <img src="@/assets/images/logo.jpg" alt="金电保" width="36" height="42" decoding="async" />
        <strong>金电保数字科技</strong>
      </a>
      <a-button
        class="site-menu-toggle"
        :icon="menuOpen ? 'close' : 'menu'"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        aria-controls="site-navigation"
        :aria-label="menuOpen ? '收起导航' : '展开导航'"
        @click="menuOpen = !menuOpen"
      />
      <nav id="site-navigation" class="site-navigation" :class="{ 'is-open': menuOpen }" aria-label="官网导航">
        <a
          v-for="item in navigation"
          :key="item.id"
          :href="sectionHref(item.id)"
          :class="{ 'is-active': isActive(item.id) }"
          :aria-current="isActive(item.id) ? 'location' : null"
          @click.prevent="navigateTo(item.id)"
        >{{ item.label }}</a>
        <router-link to="/contract_check" :class="{ 'is-active': $route.path === '/contract_check' }">保函查验</router-link>
        <router-link to="/admin/p_contract" :class="{ 'is-active': isOrderPage }">保函订单</router-link>
        <div class="site-account"><UserDrop /></div>
      </nav>
      <Login :visible="loginFlag" @cancel="cancelLogin" />
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import Login from './login/login.vue';
import UserDrop from './userdrop.vue';

export default {
  name: 'Header',
  components: { Login, UserDrop },
  data() {
    return {
      menuOpen: false,
      navigation: [
        { id: 'services', label: '服务与方案' },
        { id: 'about', label: '关于我们' },
      ],
    };
  },
  computed: {
    ...mapState('user', ['loginFlag']),
    isOrderPage() {
      return ['/admin/p_contract', '/admin/team_performance'].includes(this.$route.path);
    },
  },
  watch: {
    '$route.fullPath'() {
      this.menuOpen = false;
    },
  },
  methods: {
    sectionHref(id) {
      return id === 'col' ? '#/index' : `#/index?anch=${encodeURIComponent(`#${id}`)}`;
    },
    isActive(id) {
      if (this.$route.path !== '/index') return false;
      const anchor = this.$route.query.anch || '#col';
      return id === 'services'
        ? ['#services', '#solutions'].includes(anchor)
        : anchor === `#${id}`;
    },
    navigateTo(id) {
      this.menuOpen = false;
      const query = id === 'col' ? {} : { anch: `#${id}` };
      if (this.$route.path === '/index' && (this.$route.query.anch || '#col') === `#${id}`) {
        this.$nextTick(() => {
          const section = document.getElementById(id);
          if (section) section.scrollIntoView({ block: 'start' });
        });
      } else {
        this.$router.push({ path: '/index', query });
      }
    },
    cancelLogin() {
      this.$store.commit('user/SET_LOGINFLAG', false);
    },
  },
};
</script>

<style lang="less" scoped>
.layout-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: rgba(255, 255, 255, .94);
  -webkit-backdrop-filter: saturate(180%) blur(18px);
  backdrop-filter: saturate(180%) blur(18px);
  border-bottom: 1px solid rgba(0, 0, 0, .07);
}
.site-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  width: ~"calc(100% - 80px)";
  max-width: 1120px;
  min-height: 68px;
  margin: 0 auto;
}
.site-brand {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 12px;
  color: #1d1d1f;
  text-decoration: none;
  img { width: 36px; height: 42px; object-fit: contain; }
  strong { font-size: 18px; font-weight: 600; letter-spacing: .2px; line-height: 1.5; white-space: nowrap; }
}
.site-navigation { display: flex; align-items: center; gap: 28px; }
.site-navigation > a {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 10px 0;
  border-bottom: 2px solid transparent;
  color: #424245;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  white-space: nowrap;
  text-decoration: none;
  transition: color .15s;
  &:hover, &.is-active { color: #0066cc; }
}
.site-navigation > a.is-active { border-bottom-color: #0071e3; font-weight: 500; }
.site-account { display: flex; align-items: center; }
.site-brand:focus-visible, .site-navigation > a:focus-visible, .site-menu-toggle:focus-visible {
  outline: 2px solid #0071e3 !important;
  outline-offset: 4px;
}
.site-menu-toggle { display: none; }
@media (max-width: 960px) {
  .site-header-inner { flex-wrap: wrap; gap: 0; padding: 12px 0; }
  .site-menu-toggle { display: inline-block; width: 36px; height: 36px; padding: 0; border: 0; border-radius: 50%; background: transparent; box-shadow: none; color: #1d1d1f; }
  .site-menu-toggle:hover { background: #f5f5f7; color: #0066cc; }
  .site-navigation { display: none; }
  .site-navigation.is-open { display: grid; width: 100%; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 4px 24px; padding: 12px 0 4px; }
}
@media (max-width: 600px) {
  .site-header-inner { width: ~"calc(100% - 40px)"; min-height: 64px; }
  .site-brand { gap: 9px; img { width: 30px; height: 36px; } }
  .site-brand strong { font-size: 17px; }
  .site-navigation.is-open { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 24px; }
}
</style>
